(function() {
  'use strict';

  /* Use event delegation on document so it works for both
     desktop megamenu (rendered server-side) and mobile megamenu
     (injected by megamenu-mobile.js after DOM ready) */
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-megamenu-tab]');
    if (!tab) return;

    var megamenu = tab.closest('.megamenu--benefits') || tab.closest('.megamenu-mobile--benefits');
    if (!megamenu) return;

    var targetId = tab.getAttribute('data-megamenu-tab');

    /* Deactivate all tabs */
    megamenu.querySelectorAll('[data-megamenu-tab]').forEach(function(t) {
      t.classList.remove('is-active');
    });
    /* Deactivate all tab contents */
    megamenu.querySelectorAll('[data-megamenu-tab-content]').forEach(function(c) {
      c.classList.remove('is-active');
    });

    /* Activate clicked tab and its content */
    tab.classList.add('is-active');
    var content = megamenu.querySelector('[data-megamenu-tab-content="' + targetId + '"]');
    if (content) {
      content.classList.add('is-active');
    }

    /* Toggle per-filter footer links (desktop + mobile) */
    megamenu.querySelectorAll('[data-megamenu-footer]').forEach(function(link) {
      link.classList.remove('is-active');
    });
    var footerLink = megamenu.querySelector('[data-megamenu-footer="' + targetId + '"]');
    if (footerLink) {
      footerLink.classList.add('is-active');
    }

    /* Update mobile accordion height after tab switch */
    var collapsibleContainer = megamenu.closest('[data-collapsible-container]');
    if (collapsibleContainer) {
      var collapsibleContent = collapsibleContainer.querySelector('[data-collapsible-content]');
      if (collapsibleContent) {
        requestAnimationFrame(function() {
          collapsibleContainer.style.height = collapsibleContent.offsetHeight + 'px';
        });
      }
    }
  });
})();
